import { Container } from 'react-bootstrap';

export type BlockquoteVariant = 'primary' | 'transperant' | 'white' | 'warning-bg';

export type BlockquoteLineVariant = 'default' | 'warning' | 'green';

export type customBlockquoteProps = {
  variant?: BlockquoteVariant;
  lineVariant?: BlockquoteLineVariant;
  children: React.ReactNode;
};

const Blockquote = ({
  variant = 'primary',
  lineVariant = 'default',
  children,
}: any) => {

  return (
    <Container className={`custom-blockquote ${variant} ${lineVariant} lh-xs`}>
      {children}
    </Container>
  );
};

export default Blockquote;

